import dynamic from 'next/dynamic';

const DynamicEventCalendar = dynamic(
  () => import('./event-calendar'),
  { ssr: false }
);

export default DynamicEventCalendar;
